import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

const getBaseUrl = () => {
  const config = getApiConfig();
  return config && config.publicAccountSignupUrl
    ? config.publicAccountSignupUrl
    : '/api/account-signup/api/public/signup';
};

export default class NewRegistrationApi {
  // Turns an anonymous price-comparison into an account application — see
  // self-serve-signup.pdf. Deliberately never sends an Authorization header:
  // the caller is by definition someone without a JJ account yet, and the
  // endpoint always behaves as the public one regardless (a token is
  // ignored here, not rejected).
  static submitFromInvoice(processId, customerEmail, customerMobile) {
    const url = getBaseUrl();
    return axios
      .post(`${url}/from-invoice`, {
        processId,
        customerEmail,
        customerMobile,
      })
      .then(res => res.data);
  }
}
